import { Component } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { EnaioDocument } from 'src/modules/enaio/shared/EnaioDocument';
import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';

@Component({
  selector: 'app-enaio-result-list-view',
  templateUrl: './enaio-result-list-view.component.html',
  styleUrls: ['./enaio-result-list-view.component.scss']
})
export class EnaioResultListViewComponent extends ComponentView {

    neededParams: ObjectOfSimpleDataTypes = { id: "number" };
    id: number;

    docs: EnaioDocument[];

    async initParams(): Promise<boolean> {
        this.docs = await RestEndpoint.main().query({ id: this.id }).run("api/tst/test/documents").list(EnaioDocument);
        return true;
    }
}
